import React, { Component } from 'react';
import SVGInline from 'react-svg-inline';
import injectSheet from 'react-jss';

let WelcomeModal = (props) => {
    const { onSubmit, classes } = props;
    const done = () => {
        onSubmit(true);
    }
    return (
        <div className={`${classes.root} h-flexbox--vertical h-flexbox--se`}>
                <div className="h-flexbox--end">
                    <div className={`h-s2 h-pointer h-flexbox--sb-vc`}onClick={done}>
                        <SVGInline height="10px" svg={require('../images/close.svg')} />
                    </div>
                </div>
                <div>
                    <img className={classes.img} src={require('../images/iframewelcome@2x.png')} />
                </div>
                <div className={`${classes.title} h-s1`}>
                    Hiver has a fresh new look
                </div>
                <div className="h-s2">
                    We have made it faster and easier to use. In case you need help with 
                    anything, we are just a chat message away.
                </div>
                <div className="h-flexbox--center">
                    <div className={`${classes.link} h-s1 h-pointer`} onClick={done}>Continue</div>
                </div>
        </div>
    );
}
export default injectSheet({
    root: { height: 500 },
    img: { width: '100%'},
    title: { fontSize: 25, fontWeight: '400'},
    link: {
        color: '#35b5e5'
    }
})(WelcomeModal);
